module.exports = __webpack_public_path__ + "img/vip-selected-003-1e0a416ffafe350683e5a4f2b6621584.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/member/equity/vip-selected-003.png
// module id = 514
// module chunks = 0